import React from 'react';
import styled from 'styled-components';
import ModalHeader from '../components/advance/ModalHeader';

const EligibilityWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 26rem;
    .heading {
        margin-bottom: 2.1rem;
        text-align: left;
    }
    img {
        height: 15.3rem;
        align-self: center;
        margin-bottom: 2.3rem;
    }
    button {
        margin-left: 2.8rem;
        margin-right: 2.8rem;
        margin-top: auto;
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
`;

const EligibilityModal = () => {
    return (
        <EligibilityWrapper>
            <ModalHeader className="heading">
                <h2>Income Verification</h2>
                <p>
                    We are verifying your bank statement details, This may take upto 30 seconds. Please do not
                    leave this page.
                </p>
            </ModalHeader>
        </EligibilityWrapper>
    );
};

export default EligibilityModal;
